import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id", "aria-labelledby"];
var _hoisted_2 = {
  class: "tw-overflow-hidden"
};
var _hoisted_3 = {
  class: "tw-mb-0"
};
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'BaseAccordionContent',
  props: {
    id: {},
    accordionOpen: {
      type: Boolean
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "accordion-text-".concat(_ctx.id),
        role: "region",
        "aria-labelledby": "accordion-title-".concat(_ctx.id),
        class: _normalizeClass(["tw-grid tw-text-sm tw-text-w-black tw-overflow-hidden tw-duration-300 tw-ease-in-out tw-transition-[grid-template-rows,opacity,padding,margin] tw-px-5", [_ctx.accordionOpen ? _ctx.$attrs['accordion-open-classes'] : _ctx.$attrs['accordion-close-classes'], _ctx.accordionOpen ? 'tw-grid-rows-[1fr] tw-opacity-100' : 'tw-grid-rows-[0fr] tw-opacity-0', _ctx.$attrs['accordion-classes']]])
      }, [_renderSlot(_ctx.$slots, "custom_accordion_content", {
        isOpen: _ctx.accordionOpen
      }, () => [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {
        isOpen: _ctx.accordionOpen
      })])])])], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
}));